import React, { useContext, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import avatar from "../../assets/images/avatar.svg";
import { ProfileSection } from "../../context/ProfileContext";
import { invitationAuthoritySet } from "../../api";
import { Alert } from "../";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiUser, FiMail, FiShield, FiCheck, FiArrowLeft, FiHome } from "react-icons/fi";

const UsersSettingComp = (props) => {
  const { t } = useTranslation();
  const token = Cookies.get("token");
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const [openEditRoom, setOpenEditRoom] = useState(false);
  const invitedUser = useSelector((state) => state.invitedUser);
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const dashboardDetails = useSelector((state) => state.dashboardDetails);
  const invitedUserSetting = useSelector((state) => state.invitedUserSetting);
  let zoneIds = [];
  let zones;
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    if (invitedUserSetting !== null) {
      zoneIds = invitedUserSetting?.map((item) => {
        return item.zone_uid;
      });
    }
  }, []);

  const handlechanged = (e, id) => {
    if (e.target.checked) {
      zoneIds.push(id);
      zones = zoneIds.filter((item, pos) => {
        let result = zoneIds.indexOf(item) == pos;
        return result.toString();
      });
    } else {
      zones = zoneIds.filter((e) => e !== id);
    }
  };

  const setSettings = () => {
    const data = new FormData();
    data.append("invitation", invitedUser.id);
    data.append("zones", zones);
    data.append("dashboard", dashboardDetails.id);
    invitationAuthoritySet(data, token)
      .then(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("تنظیمات با موفقیت ثبت شد."),
          type: "Success",
        }));
        setTimeout(() => {
          ProfileShowHideFunc("firstPage");
        }, 3000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  return (
    <div className="setting-container" style={{ minHeight: "90vh" }}>
      <h2 className="setting-title">{t("تنظیمات دسترسی کاربر")}</h2>

      {/* User Info Card */}
      <div className="user-info-card">
        <div className="user-avatar-large">
          <img src={avatar} width="80" height="80" className="rounded-circle" alt="avatar" />
        </div>
        <p className="user-name-large">{invitedUser.name}</p>
        <p className="user-email-large">{invitedUser.email}</p>
      </div>

      {/* Access Settings Section */}
      <div className="tickets-section">
        <h3 className="tickets-title">
          <FiShield size={18} />
          <span>{t("دسترسی به مناطق")}</span>
        </h3>
        
        <div className="access-list">
          {dashboardZones?.map((zone, index) => {
            let invitedZoneId = invitedUserSetting?.filter((z) => {
              return z.zone_uid === zone.id;
            });
            const isChecked = invitedZoneId && invitedZoneId[0] && invitedZoneId[0]?.zone_uid === zone.id;
            
            return (
              <div className="access-item" key={index}>
                <div className="access-item-label">
                  <FiHome size={16} />
                  <span>{zone.zone_caption}</span>
                </div>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    defaultChecked={isChecked}
                    onChange={(e) => handlechanged(e, zone.id, index)}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            );
          })}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="setting-buttons">
        <button
          type="button"
          className="setting-back-btn"
          onClick={() => ProfileShowHideFunc("firstPage")}
          style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
        >
          <FiArrowLeft size={18} />
          <span>{t("بازگشت")}</span>
        </button>
        <button type="button" className="setting-back-btn" onClick={setSettings}>
          <FiCheck size={18} />
          <span>{t("تائید")}</span>
        </button>
      </div>

      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const UsersSetting = withRouter(UsersSettingComp);

export { UsersSetting };